<!--  -->
<template>
  <div>
    <section class="blog-section" style="background-image: url(/static/images/home/blog-bg.png);">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="sec-title"><span>Live broadcast center</span> 直播中心</h2>
                </div>
            </div>
            <div class="row" v-if="lives&&lives.length>0">
                <div class="col-lg-4 col-md-6" v-for="(live,index) in lives" :key="index">
                    <div class="post-item-1">
                        <img :src="`${global.remoteIp}/uploads/${live.picsrc}`" alt="">
                        <div class="b-post-details">
                            <div class="bp-meta">
                                <a href="#"><i class="icon_clock_alt"></i>{{dateFormat(new Date(live.time),"yyyy-MM-dd hh:mm")}}</a>
                                <a href="#"><i class="icon_chat_alt"></i>{{live.teacher}}</a>
                            </div>
                            <h3> <router-link :to="`/mylive/${live._id}`">{{live.title}}</router-link></h3> 
                             <router-link :to="`/mylive/${live._id}`" class="read-more">{{live.state=='1'?'正在直播':'暂未开播'}}<i v-if="live.state=='1'" class="arrow_right"></i></router-link>
                        </div>
                    </div>
                </div>
            </div>
            <el-card  v-else  class="box-card">
                  <el-empty description="暂无相关直播"></el-empty>
              </el-card>
        </div>
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      lives: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {

    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
  },

  methods: {
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style scoped>

a:not([href]):not([tabindex]) {
    color: initial !important;
}
</style>
